import { apiSlice } from "../../api-slice";
import { GroupChat, GroupChatProposalDefaultResponse, GroupChatProposalResponse } from "./proposal-chats-api-state";

export const proposalChatsAPI = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getGroupChatProposal: builder.query<GroupChat[], { proposalID: number }>({
            query: ({ proposalID }) => `/api/chat-messages/applications/${proposalID}/comments`,
            transformResponse: (response: GroupChatProposalResponse) => response.data,
            transformErrorResponse: (response: any) => response.data,
            providesTags: [{ type: 'ProposalChats', id: 'LIST' }],
        }), 
        addCommentProposal: builder.mutation<GroupChatProposalDefaultResponse, { proposalId: number; comment_text?: string; attachment?: File | null; }>({
            query: ({ proposalId, comment_text, attachment }) => {
                const formData = new FormData();

                if (comment_text?.trim()) {
                    formData.append('comment_text', comment_text.trim());
                }

                if (attachment) {
                    formData.append('attachment', attachment);
                }

                return {
                    url: `/api/chat-messages/applications/${proposalId}/comments`,
                    method: 'POST',
                    body: formData,
                };
            },
            transformErrorResponse: (response: any) => response.data,
            invalidatesTags: (_result, _error, { proposalId }) => [
                { type: 'ProposalChats', id: proposalId },
                { type: 'ProposalChats', id: 'LIST' },
            ],
        }),

        deleteCommentProposal: builder.mutation<GroupChatProposalDefaultResponse, { commentId: number}>({
            query: ({ commentId }) => ({
                url: `/api/chat-messages/comments/${commentId}`,
                method: 'DELETE',
            }),
            transformErrorResponse: (response: any) => response.data,
            invalidatesTags: (_result, _error, { commentId }) => [
                { type: 'ProposalChats', id: commentId },
                { type: 'ProposalChats', id: 'LIST' },
            ],
        }),
        updateCommentProposal: builder.mutation<GroupChatProposalDefaultResponse, { commentId: number; comment_text: string }>({
            query: ({ commentId, comment_text }) => ({
                url: `/api/chat-messages/comments/${commentId}`,
                method: 'PUT',
                body: { comment_text },
            }),
            transformErrorResponse: (response: any) => response.data,
            invalidatesTags: (_result, _error, { commentId }) => [
                { type: 'ProposalChats', id: commentId },
                { type: 'ProposalChats', id: 'LIST' },
            ],
        }),
        getCommentAttachment: builder.mutation<Blob, { commentId: number }>({
            query: ({ commentId }) => ({
                url: `/api/chat-messages/comments/${commentId}/attachment`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformErrorResponse: (response: any) => response.data,
        }),
    })
})

export const {
    useGetGroupChatProposalQuery,
    useAddCommentProposalMutation,
    useDeleteCommentProposalMutation,
    useUpdateCommentProposalMutation,
    // useGetCommentAttachmentQuery,
    useGetCommentAttachmentMutation,
} = proposalChatsAPI